import { Link } from '@tanstack/react-router';

import { Button } from './button';
import { buttonVariants } from './button-variants';
import { EmptyState } from './empty-state';

export function NotFoundPage() {
  return (
    <main className="bg-sidebar flex min-h-dvh items-center justify-center p-6">
      <EmptyState
        title="Page not found"
        description="This link may have changed. Return to your overview to continue learning."
        action={
          <Link to="/" className={buttonVariants()}>
            Back to overview
          </Link>
        }
      />
    </main>
  );
}

export function RouteError({ reset }: { reset: () => void }) {
  return (
    <main className="bg-sidebar flex min-h-dvh items-center justify-center p-6">
      <EmptyState
        title="This page couldn’t load"
        description="Try loading it again. If the problem continues, return to your overview."
        action={
          <div className="flex gap-3">
            <Button onClick={reset}>Try again</Button>
            <Link to="/" className={buttonVariants({ variant: 'secondary' })}>
              Overview
            </Link>
          </div>
        }
      />
    </main>
  );
}
